/**
 * Composition method for moa overview module
 * 
 * Author: Sahil David
 */
import { computed, onBeforeMount, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export function moaOverviewComposition () {
	const store = useStore();
	const route = useRoute();

	// Computed screen
	const screen = computed((): string => store.getters.get_moaScreen);
	const insideCell = computed((): string => store.getters.get_moaInsideCell);

	// function navigate to screen
	function switchScreen (screenTo: string): void {
		store.dispatch('axn_moaUpdateScreen', screenTo);
	}

	// Lifecycle hook
	onBeforeMount(() => {
		switchScreen('splash');
		store.dispatch('axn_updateMoaInsideCell', false);
	});

	// Query listener and navigation
	function queryListener () {
		if (!route.query) { return; }

		const { screen } = route.query;
		if (!screen) { return; }

		store.dispatch('axn_moaUpdateScreen', screen);
	}

	// Mounted lifecycle
	onMounted(() => {
		// Query listener
		queryListener();
	});

	return { screen, insideCell, switchScreen }
}

